import { render } from "./KubernetesRemoveNodes.vue?vue&type=template&id=6e5ad809"
import script from "./KubernetesRemoveNodes.vue?vue&type=script&lang=js"
export * from "./KubernetesRemoveNodes.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__